import ELFIcon from 'assets/token/ELF.svg';
import ETHIcon from 'assets/token/ETH.svg';
import BTCIcon from 'assets/token/BTC.svg';
import SGRIcon from 'assets/token/SGR.svg';
import USDTIcon from 'assets/token/USDT.svg';

const TokenIconMap: Record<string, string> = {
  ELF: ELFIcon,
  ETH: ETHIcon,
  BTC: BTCIcon,
  SGR: SGRIcon,
  USDT: USDTIcon,
};

export { TokenIconMap };
